<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,7C13,7,9,7,9,7C9,7,9,3,9,3C9,2.45,8.55,2,8,2C7.45,2,7,2.45,7,3C7,3,7,7,7,7C7,7,3,7,3,7C2.45,7,2,7.45,2,8C2,8.55,2.45,9,3,9C3,9,7,9,7,9C7,9,7,13,7,13C7,13.55,7.45,14,8,14C8.55,14,9,13.55,9,13C9,13,9,9,9,9C9,9,13,9,13,9C13.55,9,14,8.55,14,8C14,7.45,13.55,7,13,7C13,7,13,7,13,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Plus1',
} as DefineComponent
</script>
